import App from './App';
import './index.css';
import './scss/Global.scss';
import * as serviceWorker from './serviceWorker';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';

window.addEventListener('load', function () {
	ReactDOM.render(
		<React.StrictMode>
			<Router>
				<div id="ma_palletizer">
					<App />
				</div>
			</Router>
		</React.StrictMode>,
		document.getElementById('root')
	);

	// If you want your app to work offline and load faster, you can change
	// unregister() to register() below. Note this comes with some pitfalls.
	// Learn more about service workers: https://bit.ly/CRA-PWA
	serviceWorker.unregister();
});
